import axiosConfig from "./axiosConfig";

export const deleteLead = async (
  authToken: string,
  leadId: string
): Promise<{ deleted: string }> => {
  const { data } = await axiosConfig.delete(`/leads/${leadId}`, {
    headers: { Authorization: `Bearer ${authToken}` },
  });
  return data;
};
